import Vue from 'vue';
import googleMapsLoader from 'load-google-maps-api';
import GoogleMapStyles from '@app/global/googleMapStyles';
export default Vue.extend({
    props: {
        address: String,
        zoomLevel: {
            type: Number,
            default: 12,
        },
        markers: {
            type: Array,
            default: function () { return []; }
        },
        styles: {
            type: Array,
            default: null,
        },
        pinIcon: Object,
        controls: {
            type: Boolean,
            default: false,
        },
        center: Object
    },
    data: function () {
        return {
            map: null,
            googleMaps: null,
            mapMarkers: this.markers,
        };
    },
    mounted: function () {
        var _this = this;
        googleMapsLoader({
            key: window.GMAPS_API_KEY
        }).then(function (googleMaps) {
            _this.googleMaps = googleMaps;
            _this.map = new googleMaps.Map(_this.$refs.map, {
                center: _this.center,
                zoom: _this.zoomLevel,
                styles: _this.styles || GoogleMapStyles,
                disableDefaultUI: !_this.controls,
            });
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: _this.address }, function (results, status) {
                if (status.toString() == "OK") {
                    var resultLocation = results[0].geometry.location;
                    _this.map.setCenter(resultLocation);
                    _this.addMarker(resultLocation);
                }
            });
        }).catch(function (error) {
            console.error(error);
        });
    },
    methods: {
        addMarker: function (position, icon, clickHandler) {
            var _this = this;
            if (icon === void 0) { icon = null; }
            if (clickHandler === void 0) { clickHandler = null; }
            var marker = new google.maps.Marker({
                position: position,
                map: this.map,
                icon: new this.googleMaps.MarkerImage("/images/icons/map-marker-alt-light.svg", new this.googleMaps.Size(40, 40), new this.googleMaps.Point(0, 0), new this.googleMaps.Point(20, 40), new this.googleMaps.Size(40, 40))
            });
            marker.addListener('click', function (e) {
                _this.$emit('marker-click', marker);
            });
            if (clickHandler) {
                marker.addListener('click', clickHandler);
            }
            this.mapMarkers.push(marker);
        }
    }
});
